import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { CalibrationSessionType } from '../lib/calibrationTypes'

const SESSION_TYPES: CalibrationSessionType[] = [
  'upper_compound',
  'lower_compound',
  'cardio_efficiency',
  'isolation_density',
]

export function useCalibrationSessionCopy() {
  const { t } = useTranslation()

  const sessionCopy = useMemo(() => {
    const copy = {} as Record<CalibrationSessionType, { title: string; subtitle: string }>
    for (const type of SESSION_TYPES) {
      copy[type] = {
        title: t(`workout.calibration.sessions.${type}.title`),
        subtitle: t(`workout.calibration.sessions.${type}.subtitle`),
      }
    }
    return copy
  }, [t])

  return { sessionCopy, t }
}
